export default __webpack_public_path__ + "static/media/visit_membership.1faac354.svg";